export const GRAPHQL_URI = '/graphql/'
export const CONTACT_PHONE_NUMBER = '+36/30 550 6969'
